<div class="link-text-area"
     [class.is-focused]="isFocused"
     [class.has-value]="hasValue"
     (click)="handleTextAreaClick($event)"
     (focusin)="onFocusIn()"
     (focusout)="onFocusOut($event)">
  <div #editableContent
       [attr.contenteditable]="contentEditable"
       (input)="handleInput($event)"
       [innerHTML]="formattedText"
       (dblclick)="handleLinkClick($event)"
       (keydown)="handleKeyDown($event)"
       (paste)="onPaste($event)"
       (cut)="onCut($event)">
  </div>
  <label #labelForEditableContent>{{labelText}}</label>
</div>
